// generated from 5_204_733 samples

import { z } from "zod";
import { ageFilterGetSchema } from "./ageFilterGetSchema";
import { amperityCohortFilterGetSchema } from "./amperityCohortFilterGetSchema";
import { amplitudeCohortFilterGetSchema } from "./amplitudeCohortFilterGetSchema";
import { andFilterGetSchema } from "./andFilterGetSchema";
import { andNotFilterGetSchema } from "./andNotFilterGetSchema";
import { anniversaryFilterGetSchema } from "./anniversaryFilterGetSchema";
import { anyLinkClickedFilterGetSchema } from "./anyLinkClickedFilterGetSchema";
import { appVersionByAppFilterGetSchema } from "./appVersionByAppFilterGetSchema";
import { appVersionCodeByAppFilterGetSchema } from "./appVersionCodeByAppFilterGetSchema";
import { attributedAdFilterGetSchema } from "./attributedAdFilterGetSchema";
import { attributedAdgroupFilterGetSchema } from "./attributedAdgroupFilterGetSchema";
import { attributedCampaignFilterGetSchema } from "./attributedCampaignFilterGetSchema";
import { attributedSourceFilterGetSchema } from "./attributedSourceFilterGetSchema";
import { b2bFilterGetSchema } from "./b2bFilterGetSchema";
import { birthdayFilterGetSchema } from "./birthdayFilterGetSchema";
import { calculatedFilterFilterGetSchema } from "./calculatedFilterFilterGetSchema";
import { campaignLinkClickedFilterGetSchema } from "./campaignLinkClickedFilterGetSchema";
import { campaignOrCanvasWithTagRetargetFilterGetSchema } from "./campaignOrCanvasWithTagRetargetFilterGetSchema";
import { campaignRetargetFilterGetSchema } from "./campaignRetargetFilterGetSchema";
import { cardFilterGetSchema } from "./cardFilterGetSchema";
import { censusCohortFilterGetSchema } from "./censusCohortFilterGetSchema";
import { channelEngagementFilterGetSchema } from "./channelEngagementFilterGetSchema";
import { channelRankFilterGetSchema } from "./channelRankFilterGetSchema";
import { churnCategoryFilterGetSchema } from "./churnCategoryFilterGetSchema";
import { churnScoreFilterGetSchema } from "./churnScoreFilterGetSchema";
import { cityFilterGetSchema } from "./cityFilterGetSchema";
import { contextVariableFilterGetSchema } from "./contextVariableFilterGetSchema";
import { controlGroupFilterGetSchema } from "./controlGroupFilterGetSchema";
import { conversionEventFilterGetSchema } from "./conversionEventFilterGetSchema";
import { countryFilterGetSchema } from "./countryFilterGetSchema";
import { createdAtFilterGetSchema } from "./createdAtFilterGetSchema";
import { createdFromFilterGetSchema } from "./createdFromFilterGetSchema";
import { csvImportFilterGetSchema } from "./csvImportFilterGetSchema";
import { customAttributesFilterGetSchema } from "./customAttributesFilterGetSchema";
import { customEventsFilterGetSchema } from "./customEventsFilterGetSchema";
import { customEventsFirstSinceFilterGetSchema } from "./customEventsFirstSinceFilterGetSchema";
import { customEventsSinceFilterGetSchema } from "./customEventsSinceFilterGetSchema";
import { databricksCohortFilterGetSchema } from "./databricksCohortFilterGetSchema";
import { deviceBrowserFilterGetSchema } from "./deviceBrowserFilterGetSchema";
import { deviceCarrierFilterGetSchema } from "./deviceCarrierFilterGetSchema";
import { deviceCountFilterGetSchema } from "./deviceCountFilterGetSchema";
import { deviceGaidFilterGetSchema } from "./deviceGaidFilterGetSchema";
import { deviceIdfaFilterGetSchema } from "./deviceIdfaFilterGetSchema";
import { deviceIdfvFilterGetSchema } from "./deviceIdfvFilterGetSchema";
import { deviceModelFilterGetSchema } from "./deviceModelFilterGetSchema";
import { deviceOsFilterGetSchema } from "./deviceOsFilterGetSchema";
import { deviceOsVersionCodeFilterGetSchema } from "./deviceOsVersionCodeFilterGetSchema";
import { deviceRaidFilterGetSchema } from "./deviceRaidFilterGetSchema";
import { deviceWaidFilterGetSchema } from "./deviceWaidFilterGetSchema";
import { e164PhoneNumberFilterGetSchema } from "./e164PhoneNumberFilterGetSchema";
import { ecommerceSourceFilterGetSchema } from "./ecommerceSourceFilterGetSchema";
import { emailFilterGetSchema } from "./emailFilterGetSchema";
import { emailOptInSinceFilterGetSchema } from "./emailOptInSinceFilterGetSchema";
import { emailSubscriptionStatusFilterGetSchema } from "./emailSubscriptionStatusFilterGetSchema";
import { emailUnsubscribedSinceFilterGetSchema } from "./emailUnsubscribedSinceFilterGetSchema";
import { externalUserIdFilterGetSchema } from "./externalUserIdFilterGetSchema";
import { facebookFriendsFilterGetSchema } from "./facebookFriendsFilterGetSchema";
import { featureFlagMembershipFilterGetSchema } from "./featureFlagMembershipFilterGetSchema";
import { firstNameFilterGetSchema } from "./firstNameFilterGetSchema";
import { firstPurchaseByAppFilterGetSchema } from "./firstPurchaseByAppFilterGetSchema";
import { firstPurchaseSinceFilterGetSchema } from "./firstPurchaseSinceFilterGetSchema";
import { firstSessionSinceFilterGetSchema } from "./firstSessionSinceFilterGetSchema";
import { firstUsedSpecificAppFilterGetSchema } from "./firstUsedSpecificAppFilterGetSchema";
import { genderFilterGetSchema } from "./genderFilterGetSchema";
import { hardBounceFilterGetSchema } from "./hardBounceFilterGetSchema";
import { hasAdTrackingEnabledFilterGetSchema } from "./hasAdTrackingEnabledFilterGetSchema";
import { hasAppFilterGetSchema } from "./hasAppFilterGetSchema";
import { hasBackgroundPushFilterGetSchema } from "./hasBackgroundPushFilterGetSchema";
import { hasConnectedFacebookFilterGetSchema } from "./hasConnectedFacebookFilterGetSchema";
import { hasConnectedTwitterFilterGetSchema } from "./hasConnectedTwitterFilterGetSchema";
import { hasEmailFilterGetSchema } from "./hasEmailFilterGetSchema";
import { hasLocationFilterGetSchema } from "./hasLocationFilterGetSchema";
import { hasMarkedAsSpamFilterGetSchema } from "./hasMarkedAsSpamFilterGetSchema";
import { hasNeverReceivedCampaignFilterGetSchema } from "./hasNeverReceivedCampaignFilterGetSchema";
import { hasProvisionalPushByAppFilterGetSchema } from "./hasProvisionalPushByAppFilterGetSchema";
import { hasPushByAppFilterGetSchema } from "./hasPushByAppFilterGetSchema";
import { hasPushFilterGetSchema } from "./hasPushFilterGetSchema";
import { hasUninstalledFilterGetSchema } from "./hasUninstalledFilterGetSchema";
import { heapCohortFilterGetSchema } from "./heapCohortFilterGetSchema";
import { hightouchCohortFilterGetSchema } from "./hightouchCohortFilterGetSchema";
import { inAppPurchaseFilterGetSchema } from "./inAppPurchaseFilterGetSchema";
import { intelligentIpWarmingRankFilterGetSchema } from "./intelligentIpWarmingRankFilterGetSchema";
import { internalWorkflowStepRetargetFilterGetSchema } from "./internalWorkflowStepRetargetFilterGetSchema";
import { invalidNumberFilterGetSchema } from "./invalidNumberFilterGetSchema";
import { kubitCohortFilterGetSchema } from "./kubitCohortFilterGetSchema";
import { landingPageRetargetFilterGetSchema } from "./landingPageRetargetFilterGetSchema";
import { languageFilterGetSchema } from "./languageFilterGetSchema";
import { lastEnrolledInAnyControlFilterGetSchema } from "./lastEnrolledInAnyControlFilterGetSchema";
import { lastNameFilterGetSchema } from "./lastNameFilterGetSchema";
import { lastOrderPlacedCalculatedAttributeFilterGetSchema } from "./lastOrderPlacedCalculatedAttributeFilterGetSchema";
import { lastPurchaseByAppFilterGetSchema } from "./lastPurchaseByAppFilterGetSchema";
import { lastPurchaseSinceFilterGetSchema } from "./lastPurchaseSinceFilterGetSchema";
import { lastReceivedAnyCampaignFilterGetSchema } from "./lastReceivedAnyCampaignFilterGetSchema";
import { lastReceivedCampaignOrCanvasWithTagFilterGetSchema } from "./lastReceivedCampaignOrCanvasWithTagFilterGetSchema";
import { lastReceivedEmailCampaignFilterGetSchema } from "./lastReceivedEmailCampaignFilterGetSchema";
import { lastReceivedInAppMessageFilterGetSchema } from "./lastReceivedInAppMessageFilterGetSchema";
import { lastReceivedPushCampaignFilterGetSchema } from "./lastReceivedPushCampaignFilterGetSchema";
import { lastReceivedSmsCampaignFilterGetSchema } from "./lastReceivedSmsCampaignFilterGetSchema";
import { lastReceivedSpecificCampaignFilterGetSchema } from "./lastReceivedSpecificCampaignFilterGetSchema";
import { lastReceivedSpecificWorkflowStepFilterGetSchema } from "./lastReceivedSpecificWorkflowStepFilterGetSchema";
import { lastReceivedWebhookCampaignFilterGetSchema } from "./lastReceivedWebhookCampaignFilterGetSchema";
import { lastReceivedWhatsAppCampaignFilterGetSchema } from "./lastReceivedWhatsAppCampaignFilterGetSchema";
import { lastSentSpecificSmsInboundKeywordFilterGetSchema } from "./lastSentSpecificSmsInboundKeywordFilterGetSchema";
import { lastSessionSinceFilterGetSchema } from "./lastSessionSinceFilterGetSchema";
import { lastUsedSpecificAppFilterGetSchema } from "./lastUsedSpecificAppFilterGetSchema";
import { localeFilterGetSchema } from "./localeFilterGetSchema";
import { locationFilterGetSchema } from "./locationFilterGetSchema";
import { medianSessionDurationFilterGetSchema } from "./medianSessionDurationFilterGetSchema";
import { messageEngagementSinceFilterGetSchema } from "./messageEngagementSinceFilterGetSchema";
import { mixpanelCohortFilterGetSchema } from "./mixpanelCohortFilterGetSchema";
import { nestedCustomAttributesFilterGetSchema } from "./nestedCustomAttributesFilterGetSchema";
import { newsFeedViewCountFilterGetSchema } from "./newsFeedViewCountFilterGetSchema";
import { newsFeedViewedSinceFilterGetSchema } from "./newsFeedViewedSinceFilterGetSchema";
import { orFilterGetSchema } from "./orFilterGetSchema";
import { pendingArchivalFilterGetSchema } from "./pendingArchivalFilterGetSchema";
import { phoneNumberFilterGetSchema } from "./phoneNumberFilterGetSchema";
import { productPurchasedFilterGetSchema } from "./productPurchasedFilterGetSchema";
import { productPurchasedFirstSinceFilterGetSchema } from "./productPurchasedFirstSinceFilterGetSchema";
import { productPurchasedSinceFilterGetSchema } from "./productPurchasedSinceFilterGetSchema";
import { purchaseCategoryFilterGetSchema } from "./purchaseCategoryFilterGetSchema";
import { purchaseScoreFilterGetSchema } from "./purchaseScoreFilterGetSchema";
import { pushOptInSinceFilterGetSchema } from "./pushOptInSinceFilterGetSchema";
import { pushSubscriptionStatusFilterGetSchema } from "./pushSubscriptionStatusFilterGetSchema";
import { pushUnsubscribedSinceFilterGetSchema } from "./pushUnsubscribedSinceFilterGetSchema";
import { randomNumberFilterGetSchema } from "./randomNumberFilterGetSchema";
import { receivedCampaignFilterGetSchema } from "./receivedCampaignFilterGetSchema";
import { receivedCampaignVariantFilterGetSchema } from "./receivedCampaignVariantFilterGetSchema";
import { receivedCampaignWithTagFilterGetSchema } from "./receivedCampaignWithTagFilterGetSchema";
import { receivedFeatureFlagVariantFilterGetSchema } from "./receivedFeatureFlagVariantFilterGetSchema";
import { receivedWorkflowStepFilterGetSchema } from "./receivedWorkflowStepFilterGetSchema";
import { refundValueCalculatedAttributeFilterGetSchema } from "./refundValueCalculatedAttributeFilterGetSchema";
import { segmentCohortFilterGetSchema } from "./segmentCohortFilterGetSchema";
import { segmentComCohortFilterGetSchema } from "./segmentComCohortFilterGetSchema";
import { segmentMembershipFilterGetSchema } from "./segmentMembershipFilterGetSchema";
import { sessionCountByAppFilterGetSchema } from "./sessionCountByAppFilterGetSchema";
import { sessionCountFilterGetSchema } from "./sessionCountFilterGetSchema";
import { subscriptionGroupFilterGetSchema } from "./subscriptionGroupFilterGetSchema";
import { submittedSurveyCampaignFilterGetSchema } from "./submittedSurveyCampaignFilterGetSchema";
import { submittedSurveyLandingPageFilterGetSchema } from "./submittedSurveyLandingPageFilterGetSchema";
import { submittedSurveyWorkflowStepFilterGetSchema } from "./submittedSurveyWorkflowStepFilterGetSchema";
import { tinycluesCohortFilterGetSchema } from "./tinycluesCohortFilterGetSchema";
import { totalNumberOfPurchasesFilterGetSchema } from "./totalNumberOfPurchasesFilterGetSchema";
import { totalOrdersFilterGetSchema } from "./totalOrdersFilterGetSchema";
import { totalRevenueFilterGetSchema } from "./totalRevenueFilterGetSchema";
import { treasureDataCohortFilterGetSchema } from "./treasureDataCohortFilterGetSchema";
import { twitterFollowersFilterGetSchema } from "./twitterFollowersFilterGetSchema";
import { uninstallFilterGetSchema } from "./uninstallFilterGetSchema";
import { updatedAtFilterGetSchema } from "./updatedAtFilterGetSchema";
import { watchModelFilterGetSchema } from "./watchModelFilterGetSchema";
import { workflowControlGroupFilterGetSchema } from "./workflowControlGroupFilterGetSchema";
import { workflowConversionEventFilterGetSchema } from "./workflowConversionEventFilterGetSchema";
import { workflowEnteredVariationFilterGetSchema } from "./workflowEnteredVariationFilterGetSchema";
import { workflowLinkClickedFilterGetSchema } from "./workflowLinkClickedFilterGetSchema";
import { workflowStepRetargetFilterGetSchema } from "./workflowStepRetargetFilterGetSchema";
import { xCustomEventInYDaysGetSchema } from "./xCustomEventInYDaysGetSchema";
import { xCustomEventPropertyInYDaysGetSchema } from "./xCustomEventPropertyInYDaysGetSchema";
import { xMoneySpentInYDaysGetSchema } from "./xMoneySpentInYDaysGetSchema";
import { xPurchasesInYDaysGetSchema } from "./xPurchasesInYDaysGetSchema";
import { xSessionsInYDaysGetSchema } from "./xSessionsInYDaysGetSchema";
import { xSoftBouncesInYDaysGetSchema } from "./xSoftBouncesInYDaysGetSchema";
import { xSpecificPurchaseInYDaysGetSchema } from "./xSpecificPurchaseInYDaysGetSchema";
import { xSpecificPurchasePropertyInYDaysGetSchema } from "./xSpecificPurchasePropertyInYDaysGetSchema";

export const filterGetSchema = z.discriminatedUnion("filter_key", [
  ageFilterGetSchema,
  amperityCohortFilterGetSchema,
  amplitudeCohortFilterGetSchema,
  andFilterGetSchema,
  andNotFilterGetSchema,
  anniversaryFilterGetSchema,
  anyLinkClickedFilterGetSchema,
  appVersionByAppFilterGetSchema,
  appVersionCodeByAppFilterGetSchema,
  attributedAdFilterGetSchema,
  attributedAdgroupFilterGetSchema,
  attributedCampaignFilterGetSchema,
  attributedSourceFilterGetSchema,
  b2bFilterGetSchema,
  birthdayFilterGetSchema,
  calculatedFilterFilterGetSchema,
  campaignLinkClickedFilterGetSchema,
  campaignOrCanvasWithTagRetargetFilterGetSchema,
  campaignRetargetFilterGetSchema,
  cardFilterGetSchema,
  censusCohortFilterGetSchema,
  channelEngagementFilterGetSchema,
  channelRankFilterGetSchema,
  churnCategoryFilterGetSchema,
  churnScoreFilterGetSchema,
  cityFilterGetSchema,
  contextVariableFilterGetSchema,
  controlGroupFilterGetSchema,
  conversionEventFilterGetSchema,
  countryFilterGetSchema,
  createdAtFilterGetSchema,
  createdFromFilterGetSchema,
  csvImportFilterGetSchema,
  customAttributesFilterGetSchema,
  customEventsFilterGetSchema,
  customEventsFirstSinceFilterGetSchema,
  customEventsSinceFilterGetSchema,
  databricksCohortFilterGetSchema,
  deviceBrowserFilterGetSchema,
  deviceCarrierFilterGetSchema,
  deviceCountFilterGetSchema,
  deviceGaidFilterGetSchema,
  deviceIdfaFilterGetSchema,
  deviceIdfvFilterGetSchema,
  deviceModelFilterGetSchema,
  deviceOsFilterGetSchema,
  deviceOsVersionCodeFilterGetSchema,
  deviceRaidFilterGetSchema,
  deviceWaidFilterGetSchema,
  e164PhoneNumberFilterGetSchema,
  ecommerceSourceFilterGetSchema,
  emailFilterGetSchema,
  emailOptInSinceFilterGetSchema,
  emailSubscriptionStatusFilterGetSchema,
  emailUnsubscribedSinceFilterGetSchema,
  externalUserIdFilterGetSchema,
  facebookFriendsFilterGetSchema,
  featureFlagMembershipFilterGetSchema,
  firstNameFilterGetSchema,
  firstPurchaseByAppFilterGetSchema,
  firstPurchaseSinceFilterGetSchema,
  firstSessionSinceFilterGetSchema,
  firstUsedSpecificAppFilterGetSchema,
  genderFilterGetSchema,
  hardBounceFilterGetSchema,
  hasAdTrackingEnabledFilterGetSchema,
  hasAppFilterGetSchema,
  hasBackgroundPushFilterGetSchema,
  hasConnectedFacebookFilterGetSchema,
  hasConnectedTwitterFilterGetSchema,
  hasEmailFilterGetSchema,
  hasLocationFilterGetSchema,
  hasMarkedAsSpamFilterGetSchema,
  hasNeverReceivedCampaignFilterGetSchema,
  hasProvisionalPushByAppFilterGetSchema,
  hasPushByAppFilterGetSchema,
  hasPushFilterGetSchema,
  hasUninstalledFilterGetSchema,
  heapCohortFilterGetSchema,
  hightouchCohortFilterGetSchema,
  inAppPurchaseFilterGetSchema,
  intelligentIpWarmingRankFilterGetSchema,
  internalWorkflowStepRetargetFilterGetSchema,
  invalidNumberFilterGetSchema,
  kubitCohortFilterGetSchema,
  landingPageRetargetFilterGetSchema,
  languageFilterGetSchema,
  lastEnrolledInAnyControlFilterGetSchema,
  lastNameFilterGetSchema,
  lastOrderPlacedCalculatedAttributeFilterGetSchema,
  lastPurchaseByAppFilterGetSchema,
  lastPurchaseSinceFilterGetSchema,
  lastReceivedAnyCampaignFilterGetSchema,
  lastReceivedCampaignOrCanvasWithTagFilterGetSchema,
  lastReceivedEmailCampaignFilterGetSchema,
  lastReceivedInAppMessageFilterGetSchema,
  lastReceivedPushCampaignFilterGetSchema,
  lastReceivedSmsCampaignFilterGetSchema,
  lastReceivedSpecificCampaignFilterGetSchema,
  lastReceivedSpecificWorkflowStepFilterGetSchema,
  lastReceivedWebhookCampaignFilterGetSchema,
  lastReceivedWhatsAppCampaignFilterGetSchema,
  lastSentSpecificSmsInboundKeywordFilterGetSchema,
  lastSessionSinceFilterGetSchema,
  lastUsedSpecificAppFilterGetSchema,
  localeFilterGetSchema,
  locationFilterGetSchema,
  medianSessionDurationFilterGetSchema,
  messageEngagementSinceFilterGetSchema,
  mixpanelCohortFilterGetSchema,
  nestedCustomAttributesFilterGetSchema,
  newsFeedViewCountFilterGetSchema,
  newsFeedViewedSinceFilterGetSchema,
  orFilterGetSchema,
  pendingArchivalFilterGetSchema,
  phoneNumberFilterGetSchema,
  productPurchasedFilterGetSchema,
  productPurchasedFirstSinceFilterGetSchema,
  productPurchasedSinceFilterGetSchema,
  purchaseCategoryFilterGetSchema,
  purchaseScoreFilterGetSchema,
  pushOptInSinceFilterGetSchema,
  pushSubscriptionStatusFilterGetSchema,
  pushUnsubscribedSinceFilterGetSchema,
  randomNumberFilterGetSchema,
  receivedCampaignFilterGetSchema,
  receivedCampaignVariantFilterGetSchema,
  receivedCampaignWithTagFilterGetSchema,
  receivedFeatureFlagVariantFilterGetSchema,
  receivedWorkflowStepFilterGetSchema,
  refundValueCalculatedAttributeFilterGetSchema,
  segmentCohortFilterGetSchema,
  segmentComCohortFilterGetSchema,
  segmentMembershipFilterGetSchema,
  sessionCountByAppFilterGetSchema,
  sessionCountFilterGetSchema,
  subscriptionGroupFilterGetSchema,
  submittedSurveyCampaignFilterGetSchema,
  submittedSurveyLandingPageFilterGetSchema,
  submittedSurveyWorkflowStepFilterGetSchema,
  tinycluesCohortFilterGetSchema,
  totalNumberOfPurchasesFilterGetSchema,
  totalOrdersFilterGetSchema,
  totalRevenueFilterGetSchema,
  treasureDataCohortFilterGetSchema,
  twitterFollowersFilterGetSchema,
  uninstallFilterGetSchema,
  updatedAtFilterGetSchema,
  watchModelFilterGetSchema,
  workflowControlGroupFilterGetSchema,
  workflowConversionEventFilterGetSchema,
  workflowEnteredVariationFilterGetSchema,
  workflowLinkClickedFilterGetSchema,
  workflowStepRetargetFilterGetSchema,
  xCustomEventInYDaysGetSchema,
  xCustomEventPropertyInYDaysGetSchema,
  xMoneySpentInYDaysGetSchema,
  xPurchasesInYDaysGetSchema,
  xSessionsInYDaysGetSchema,
  xSoftBouncesInYDaysGetSchema,
  xSpecificPurchaseInYDaysGetSchema,
  xSpecificPurchasePropertyInYDaysGetSchema,
]);
